import styles from "../input/inputs.module.css";

export const TextInput = ({ style = "",inputRight=null, ...rest }) => {
    return <input className={`${styles.formInput} ${style} ${styles[inputRight]}`}  {...rest} />
}

export const FormTextArea = ({style="", ...rest})=>{
    return <textarea className={`${styles.textArea} ${style}`} {...rest}/>
  }